import { Component, OnInit, Inject } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  GlobalConstantsRegex,
  GlobalConstantsSonstige,
  InputErrorStateMatcher,
  ValueFormat,
} from 'globales-projekt-angular';
import { UserQuelleFlaeche } from 'src/app/data/user/user-quelle-flaeche.model';
import { UserQuelleSonstige } from 'src/app/data/user/user-quelle-sonstige.model';
import { UserQuelleStall } from 'src/app/data/user/user-quelle-stall.model';
import { MinderungsmassnahmeFlaeche } from 'src/app/data/ws/minderungsmassnahme-flaeche.model';
import { MinderungsmassnahmeTierkategorie } from 'src/app/data/ws/minderungsmassnahme-tierkategorie.model';
import { Tierkategorie } from 'src/app/data/ws/tierkategorie.model';
import { TkHvGeruchsemission } from 'src/app/data/ws/tk-hv-geruchsemission.model';
import { Behaeltergeometrien } from 'src/app/immutable/enums/behaeltergeometrien';
import { QuelleTyp } from 'src/app/immutable/enums/quelle-typ';
import { LocalService } from 'src/app/services/local.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { KoordinatenHilfeDialogComponent } from 'src/app/components/elemente/koordinaten-hilfe-dialog/koordinaten-hilfe-dialog.component';

@Component({
  selector: 'app-modal-auswahl-quelle',
  templateUrl: './modal-auswahl-quelle.component.html',
  styleUrls: ['./modal-auswahl-quelle.component.css'],
})
export class ModalAuswahlQuelleComponent implements OnInit {
  private koordinatenHilfeDialogRef: MatDialogRef<KoordinatenHilfeDialogComponent> | null = null;

  tooltipPosition = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);
  matcher: InputErrorStateMatcher = new InputErrorStateMatcher();

  valueFormat: ValueFormat = new ValueFormat();
  userQuelleStall = new UserQuelleStall();
  userQuelleFlaeche = new UserQuelleFlaeche();
  userQuelleSonstige = new UserQuelleSonstige();

  selectedTierkategorienList: Tierkategorie[];
  selectedMinderungsmassnahmeTierkategorieList: MinderungsmassnahmeTierkategorie[];
  selectedMinderungsmassnahmeFlaecheList: MinderungsmassnahmeFlaeche[];
  selectedTkHvGeruchsemissionList: TkHvGeruchsemission[];

  formControlGanzZahlLaeng4NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_TEXT);
  formControlGanzZahlPositivNegativLaeng4NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_POSITIV_NEGATIV_TEXT);
  formControlGewichtungsfaktorFNumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GEWICHTUNGSFAKTOR_F_TEXT);
  formControlGanzZahlLaeng4OderKomma1NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_1_TEXT);
  formControlGanzZahlLaeng4OderKomma2NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_2_TEXT);
  formControlGanzZahlLaeng2OderKomma1NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_1_TEXT);
  formControlGanzZahlLaeng2OderKomma2NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_2_TEXT);
  formControlGanzZahlLaeng5Ohne0NumberWarning: string = GlobalConstantsRegex.getRegexTextBuilderZahl(GlobalConstantsRegex.GANZ_ZAHL_LAENG_5_OHNE_0_TEXT);

  // Allgemein
  quelleFormControl: FormControl = new FormControl(null);
  bezeichnungFormControl: FormControl = new FormControl(null, Validators.required);

  // Stall
  stallTierartFormControl: FormControl = new FormControl(null);
  stallTierkategorieFormControl: FormControl = new FormControl(null);
  stallHaltungsverfahrenFormControl: FormControl = new FormControl(null);
  stallMinderungsmassnahmeFormControl: FormControl = new FormControl(null);
  stallWirkungsgradFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_1),]);
  stallAnzahlTiereFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_5_OHNE_0),]);
  stallGewichtungsfaktorFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GEWICHTUNGSFAKTOR_F),]);
  stallXKoordinateFormControl: FormControl = new FormControl(0, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_POSITIV_NEGATIV),]);
  stallYKoordinateFormControl: FormControl = new FormControl(0, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_POSITIV_NEGATIV),]);
  stallQuellenspezZusatzabstandFormControl: FormControl = new FormControl(0, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_1),]);

  // Flaeche
  flaecheFlaechenquellartFormControl: FormControl = new FormControl(null);
  flaecheMinderungsmassnahmeFormControl: FormControl = new FormControl(null);
  flaecheWirkungsgradFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_1),]);
  flaecheGewichtungsfaktorFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GEWICHTUNGSFAKTOR_F),]);
  flaecheXKoordinateFormControl: FormControl = new FormControl(0, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_POSITIV_NEGATIV),]);
  flaecheYKoordinateFormControl: FormControl = new FormControl(0, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_POSITIV_NEGATIV),]);
  flaecheLaengeHoeheFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_1),]);
  flaecheBreiteFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_1),]);
  flaecheDurchmesserFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_1),]);

  // Sonstige
  sonstigeEmissionFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4),]);
  sonstigeGewichtungsfaktorFormControl: FormControl = new FormControl(null, [Validators.pattern(GlobalConstantsRegex.GEWICHTUNGSFAKTOR_F),]);
  sonstigeXKoordinateFormControl: FormControl = new FormControl(0, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_POSITIV_NEGATIV),]);
  sonstigeYKoordinateFormControl: FormControl = new FormControl(0, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_POSITIV_NEGATIV),]);
  sonstigeQuellenspezZusatzabstandFormControl: FormControl = new FormControl(0, [Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_4_ODER_KOMMA_1)]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public isEdit: boolean,
    public localService: LocalService,
    private dialog: MatDialog
  ) {
  }

  openKoordinatenHilfe(event: MouseEvent): void {
    if (this.koordinatenHilfeDialogRef) {
      return;
    }

    const abstandZumIcon = 12;
    const dialogBreite = Math.min(520, window.innerWidth * 0.65);
    const platzRechts = event.clientX + abstandZumIcon + dialogBreite <= window.innerWidth;
    const links = platzRechts
      ? event.clientX + abstandZumIcon
      : event.clientX - dialogBreite - abstandZumIcon;
    const oben = Math.max(16, Math.min(event.clientY - 40, window.innerHeight - 560));

    const dialogRef = this.dialog.open(KoordinatenHilfeDialogComponent, {
      width: `${dialogBreite}px`,
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: '75vh',
      hasBackdrop: false,
      autoFocus: false,
      restoreFocus: false,
      position: {
        left: `${Math.max(16, links)}px`,
        top: `${oben}px`
      }
    });

    this.koordinatenHilfeDialogRef = dialogRef;

    dialogRef.afterClosed().subscribe(() => {
      if (this.koordinatenHilfeDialogRef === dialogRef) {
        this.koordinatenHilfeDialogRef = null;
      }
    });
  }

  closeKoordinatenHilfe(): void {
    this.koordinatenHilfeDialogRef?.close();
  }

  ngOnInit(): void {
  }

  public getQuelle(): QuelleTyp {
    return this.quelleFormControl.value;
  }

  public getUserStallquelle(): UserQuelleStall {
    return this.userQuelleStall;
  }

  public getUserFlaechenquelle(): UserQuelleFlaeche {
    return this.userQuelleFlaeche;
  }

  public getUserSonstigeQuelle(): UserQuelleSonstige {
    return this.userQuelleSonstige;
  }

  public setUserStallquelle(userQuelleStall: UserQuelleStall) {
    this.quelleFormControl.setValue(QuelleTyp.STALL);
    this.bezeichnungFormControl.setValue(userQuelleStall.bezeichnung);

    this.stallTierartFormControl.setValue(userQuelleStall.idTierart);
    this.stallTierartFormControl.updateValueAndValidity();
    this.onSelectStallTierart();

    this.stallTierkategorieFormControl.setValue(userQuelleStall.idTierkategorie);
    this.stallTierkategorieFormControl.updateValueAndValidity();
    this.onSelectStallTierkategorie();

    this.stallHaltungsverfahrenFormControl.setValue(userQuelleStall.idTkHvGeruchsemissionZuord);
    this.stallMinderungsmassnahmeFormControl.setValue(userQuelleStall.idMmTierartenZuord);
    this.stallGewichtungsfaktorFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleStall.gewichtungsfaktor, 2));
    this.stallWirkungsgradFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleStall.wirkungsgrad, 1));
    this.stallAnzahlTiereFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleStall.anzahlTiere, 0));
    this.stallXKoordinateFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleStall.xKoordinate, 0));
    this.stallYKoordinateFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleStall.yKoordinate, 0));
    this.stallQuellenspezZusatzabstandFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleStall.quellenspezZusatzabstand, 1));

    this.stallHaltungsverfahrenFormControl.updateValueAndValidity();
    this.stallMinderungsmassnahmeFormControl.updateValueAndValidity();
    this.stallAnzahlTiereFormControl.updateValueAndValidity();
    this.stallWirkungsgradFormControl.updateValueAndValidity();
    this.stallGewichtungsfaktorFormControl.updateValueAndValidity();
    this.stallXKoordinateFormControl.updateValueAndValidity();
    this.stallYKoordinateFormControl.updateValueAndValidity();
    this.stallQuellenspezZusatzabstandFormControl.updateValueAndValidity();
  }

  public setUserFlaechenquelle(userQuelleFlaeche: UserQuelleFlaeche) {
    this.quelleFormControl.setValue(QuelleTyp.FLAECHE);
    this.bezeichnungFormControl.setValue(userQuelleFlaeche.bezeichnung);

    this.flaecheFlaechenquellartFormControl.setValue(userQuelleFlaeche.idFlaechenquellart);
    this.onSelectFlaecheFlaechenquelle();
    this.flaecheMinderungsmassnahmeFormControl.setValue(userQuelleFlaeche.idMmFlaechenZuord);
    this.flaecheMinderungsmassnahmeFormControl.disable();
    this.onSelectFlaecheMinderungsmassnahme();

    this.flaecheWirkungsgradFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleFlaeche.wirkungsgrad, 1));
    this.flaecheLaengeHoeheFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleFlaeche.laengeHoehe, 1));
    this.flaecheBreiteFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleFlaeche.breite, 1));
    this.flaecheDurchmesserFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleFlaeche.durchmesser, 1));
    this.flaecheXKoordinateFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleFlaeche.xKoordinate, 0));
    this.flaecheYKoordinateFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleFlaeche.yKoordinate, 0));


    this.flaecheWirkungsgradFormControl.updateValueAndValidity();
    this.flaecheLaengeHoeheFormControl.updateValueAndValidity();
    this.flaecheBreiteFormControl.updateValueAndValidity();
    this.flaecheDurchmesserFormControl.updateValueAndValidity();
    this.flaecheXKoordinateFormControl.updateValueAndValidity();
    this.flaecheYKoordinateFormControl.updateValueAndValidity();
  }

  public setUserSonstigeQuelle(userQuelleSonstige: UserQuelleSonstige) {
    this.quelleFormControl.setValue(QuelleTyp.SONSTIGE);
    this.bezeichnungFormControl.setValue(userQuelleSonstige.bezeichnung);

    this.sonstigeGewichtungsfaktorFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleSonstige.gewichtungsfaktor, 2));
    this.sonstigeEmissionFormControl.setValue(userQuelleSonstige.emissionGe);
    this.sonstigeXKoordinateFormControl.setValue(userQuelleSonstige.xKoordinate);
    this.sonstigeYKoordinateFormControl.setValue(userQuelleSonstige.yKoordinate);
    this.sonstigeQuellenspezZusatzabstandFormControl.setValue(this.valueFormat.getStringDecimal(userQuelleSonstige.quellenspezZusatzabstand, 1));


    this.sonstigeGewichtungsfaktorFormControl.updateValueAndValidity()
    this.sonstigeEmissionFormControl.updateValueAndValidity();
    this.sonstigeXKoordinateFormControl.updateValueAndValidity();
    this.sonstigeYKoordinateFormControl.updateValueAndValidity();
    this.sonstigeQuellenspezZusatzabstandFormControl.updateValueAndValidity();
  }

  assignEingabeQuelleToObject(): void {
    let quelleTyp: number = this.quelleFormControl.value;

    if (quelleTyp == QuelleTyp.STALL) {
      this.userQuelleStall.bezeichnung = this.bezeichnungFormControl.value;
      this.userQuelleStall.idTierart = this.stallTierartFormControl.value;
      this.userQuelleStall.idTierkategorie = this.stallTierkategorieFormControl.value;
      this.userQuelleStall.idMmTierartenZuord = this.stallMinderungsmassnahmeFormControl.value;
      this.userQuelleStall.idTkHvGeruchsemissionZuord = this.stallHaltungsverfahrenFormControl.value;
      this.userQuelleStall.wirkungsgrad = this.valueFormat.parseNumber(this.stallWirkungsgradFormControl.value);
      this.userQuelleStall.anzahlTiere = this.valueFormat.parseNumber(this.stallAnzahlTiereFormControl.value);
      this.userQuelleStall.gewichtungsfaktor = this.valueFormat.parseNumber(this.stallGewichtungsfaktorFormControl.value);
      this.userQuelleStall.xKoordinate = this.valueFormat.parseNumber(this.stallXKoordinateFormControl.value);
      this.userQuelleStall.yKoordinate = this.valueFormat.parseNumber(this.stallYKoordinateFormControl.value);
      this.userQuelleStall.quellenspezZusatzabstand = this.valueFormat.parseNumber(this.stallQuellenspezZusatzabstandFormControl.value);
 

    } else if (quelleTyp == QuelleTyp.FLAECHE) {
      this.userQuelleFlaeche.bezeichnung = this.bezeichnungFormControl.value;
      this.userQuelleFlaeche.idFlaechenquellart = this.flaecheFlaechenquellartFormControl.value;
      this.userQuelleFlaeche.idMmFlaechenZuord = this.flaecheMinderungsmassnahmeFormControl.value;
      this.userQuelleFlaeche.wirkungsgrad = this.valueFormat.parseNumber(this.flaecheWirkungsgradFormControl.value);
      this.userQuelleFlaeche.gewichtungsfaktor = this.valueFormat.parseNumber(this.flaecheGewichtungsfaktorFormControl.value);
      this.userQuelleFlaeche.laengeHoehe = this.valueFormat.parseNumber(this.flaecheLaengeHoeheFormControl.value);
      this.userQuelleFlaeche.breite = this.valueFormat.parseNumber(this.flaecheBreiteFormControl.value);
      this.userQuelleFlaeche.durchmesser = this.valueFormat.parseNumber(this.flaecheDurchmesserFormControl.value);
      this.userQuelleFlaeche.xKoordinate = this.valueFormat.parseNumber(this.flaecheXKoordinateFormControl.value);
      this.userQuelleFlaeche.yKoordinate = this.valueFormat.parseNumber(this.flaecheYKoordinateFormControl.value
      );
    } else if (quelleTyp == QuelleTyp.SONSTIGE) {
      this.userQuelleSonstige.bezeichnung = this.bezeichnungFormControl.value;
      this.userQuelleSonstige.emissionGe = this.valueFormat.parseNumber(this.sonstigeEmissionFormControl.value);
      this.userQuelleSonstige.xKoordinate = this.valueFormat.parseNumber(this.sonstigeXKoordinateFormControl.value);
      this.userQuelleSonstige.yKoordinate = this.valueFormat.parseNumber(this.sonstigeYKoordinateFormControl.value);
      this.userQuelleSonstige.quellenspezZusatzabstand = this.valueFormat.parseNumber(this.sonstigeQuellenspezZusatzabstandFormControl.value);
      this.userQuelleSonstige.gewichtungsfaktor = this.valueFormat.parseNumber(this.sonstigeGewichtungsfaktorFormControl.value);
    }
  }

  // Anfang-Stall

  onSelectStallTierart() {
    let idTierart: number = this.stallTierartFormControl.value;

    this.selectedTierkategorienList = this.localService.tierkategorieList.value.filter(
      (item) => item.idTierart == idTierart
    );

    this.selectedMinderungsmassnahmeTierkategorieList =
      this.localService.minderungsmassnahmeTierkategorieList.value.filter(
        (item) => item.idTierart == idTierart
      );

    this.selectedTkHvGeruchsemissionList = null;
    this.stallTierkategorieFormControl.setValue(null);
    this.stallTierkategorieFormControl.enable();
    this.stallHaltungsverfahrenFormControl.disable();
    this.stallMinderungsmassnahmeFormControl.disable();
  }

  onSelectStallTierkategorie() {
    for (let entry of this.selectedMinderungsmassnahmeTierkategorieList) {
      if (entry.wirkungsgrad == 0)
        this.stallMinderungsmassnahmeFormControl.setValue(entry.idMmTierartenZuord);
    }

    this.stallMinderungsmassnahmeFormControl.setValue(null);
    this.stallMinderungsmassnahmeFormControl.enable();
    this.stallWirkungsgradFormControl.disable();

    for (let entry of this.selectedMinderungsmassnahmeTierkategorieList) {
      if (entry.wirkungsgrad == 0) {
        this.stallMinderungsmassnahmeFormControl.setValue(entry.idMmTierartenZuord);
        this.onSelectStallMinderungsmassnahmeTier();
      }
    }

    let idTierkategorie: number = this.stallTierkategorieFormControl.value;

    this.selectedTkHvGeruchsemissionList = this.localService.tkHvGeruchsemissionList.value.filter((item) => item.idTierkategorie == idTierkategorie);



    if (this.selectedTkHvGeruchsemissionList.length == 1) {
      this.stallHaltungsverfahrenFormControl.setValue(this.selectedTkHvGeruchsemissionList[0].idTkHvGeruchsemissionZuord);
      this.stallGewichtungsfaktorFormControl.setValue(this.valueFormat.getStringDecimal(this.selectedTkHvGeruchsemissionList[0].gewichtungsfaktor, 2));
    } else {
      this.stallHaltungsverfahrenFormControl.setValue(null);
    }
    this.stallHaltungsverfahrenFormControl.enable();
  }

  onSelectStallTkHvGeruchsemission() {
    const idTkHvGeruchsemissionZuord: number = this.stallHaltungsverfahrenFormControl.value;

    const selectedTkHv = this.selectedTkHvGeruchsemissionList.find(
      item => item.idTkHvGeruchsemissionZuord === idTkHvGeruchsemissionZuord
    );

    this.stallMinderungsmassnahmeFormControl.enable();
    this.stallGewichtungsfaktorFormControl.setValue(this.valueFormat.getStringDecimal(selectedTkHv.gewichtungsfaktor, 2));
  }

  onSelectStallMinderungsmassnahmeTier() {
    let minderungsmassnahmeTierkategorie: MinderungsmassnahmeTierkategorie =
      this.selectedMinderungsmassnahmeTierkategorieList.filter(
        (item) => item.idMmTierartenZuord == this.stallMinderungsmassnahmeFormControl.value
      )[0];

    if (minderungsmassnahmeTierkategorie.wirkungsgrad == null) {
      this.stallWirkungsgradFormControl.enable();
      this.stallWirkungsgradFormControl.setValue(this.valueFormat.getStringDecimal(0, 1));
    } else {
      this.stallWirkungsgradFormControl.disable();
      this.stallWirkungsgradFormControl.setValue(this.valueFormat.getStringDecimal(
        minderungsmassnahmeTierkategorie.wirkungsgrad,
        1
      )
      );
    }
  }

  onSelectFlaecheMinderungsmassnahme() {
    let minderungsmassnahmeFlaeche: MinderungsmassnahmeFlaeche =
      this.selectedMinderungsmassnahmeFlaecheList.filter(
        (item) => item.idMmFlaechenZuord == this.flaecheMinderungsmassnahmeFormControl.value
      )[0];

    if (minderungsmassnahmeFlaeche.wirkungsgrad == null) {
      this.flaecheWirkungsgradFormControl.enable();
      this.flaecheWirkungsgradFormControl.setValue(this.valueFormat.getStringDecimal(0, 1));
    } else {
      this.flaecheWirkungsgradFormControl.disable();
      this.flaecheWirkungsgradFormControl.setValue(this.valueFormat.getStringDecimal(minderungsmassnahmeFlaeche.wirkungsgrad, 1)
      );
    }
  }
  // Ende-Stall
  // Anfang-Fläche 
  onSelectFlaecheFlaechenquelle() {
    let idFlaechenquellart: number = this.flaecheFlaechenquellartFormControl.value;

    this.selectedMinderungsmassnahmeFlaecheList =
      this.localService.minderungsmassnahmeFlaechenList.value.filter(
        (item) => item.idFlaechenquellart == idFlaechenquellart
      );

    this.flaecheMinderungsmassnahmeFormControl.setValue(null);
    this.flaecheMinderungsmassnahmeFormControl.enable();

    for (let entry of this.localService.flaechenquellartList.value) {
      if (idFlaechenquellart == entry.idFlaechenquellart) {
        if (entry.idBehaeltergeometrie == Behaeltergeometrien.RUND) {
          this.flaecheLaengeHoeheFormControl.setValue(
            this.valueFormat.getStringDecimal(0, 1)
          );
          this.flaecheBreiteFormControl.setValue(
            this.valueFormat.getStringDecimal(0, 1)
          );
          this.flaecheDurchmesserFormControl.enable();
          this.flaecheLaengeHoeheFormControl.disable();
          this.flaecheBreiteFormControl.disable();
        } else {
          this.flaecheDurchmesserFormControl.setValue(
            this.valueFormat.getStringDecimal(0, 1)
          );
          this.flaecheDurchmesserFormControl.disable();
          this.flaecheLaengeHoeheFormControl.enable();
          this.flaecheBreiteFormControl.enable();
        }

        this.flaecheGewichtungsfaktorFormControl.enable();

        this.flaecheGewichtungsfaktorFormControl.setValue(
          this.valueFormat.getStringDecimal(entry.gewichtungsfaktor, 2)
        );
        break;
      }
    }
  }
  // Ende-Fläche
  // Anfang-Sonstige
  // Ende-Sonstige



  onClickUebernehmen() {
    this.assignEingabeQuelleToObject();
  }

  private readonly baseControls = [
    this.quelleFormControl,
    this.bezeichnungFormControl,
  ] as const;

  private readonly typeControls: Record<number, readonly any[]> = {
    [QuelleTyp.STALL]: [
      this.stallTierartFormControl,
      this.stallTierkategorieFormControl,
      this.stallHaltungsverfahrenFormControl,
      this.stallMinderungsmassnahmeFormControl,
      this.stallWirkungsgradFormControl,
      this.stallAnzahlTiereFormControl,
      this.stallGewichtungsfaktorFormControl,
      this.stallXKoordinateFormControl,
      this.stallYKoordinateFormControl,
      this.stallQuellenspezZusatzabstandFormControl,
    ],
    [QuelleTyp.FLAECHE]: [
      this.flaecheFlaechenquellartFormControl,
      this.flaecheMinderungsmassnahmeFormControl,
      this.flaecheWirkungsgradFormControl,
      this.flaecheGewichtungsfaktorFormControl,
      this.flaecheXKoordinateFormControl,
      this.flaecheYKoordinateFormControl,
      this.flaecheDurchmesserFormControl,
      this.flaecheLaengeHoeheFormControl,
      this.flaecheBreiteFormControl,
    ],
    [QuelleTyp.SONSTIGE]: [
      this.sonstigeEmissionFormControl,
      this.sonstigeGewichtungsfaktorFormControl,
      this.sonstigeXKoordinateFormControl,
      this.sonstigeYKoordinateFormControl,
      this.sonstigeQuellenspezZusatzabstandFormControl,
    ],
  };

  private isControlOk(c: AbstractControl | null | undefined): boolean {
    if (!c) return false;
    return c.disabled || c.valid;
  }

  isFormValid(): boolean {
    const quelleTyp = this.quelleFormControl.value as number;

    const controls = [
      ...this.baseControls,
      ...(this.typeControls[quelleTyp] ?? []),
    ];

    return controls.every(c => this.isControlOk(c));
  }
}